import './TransactionHistory.css';

const TransactionItem = ({ item }) => {
  return (
    <tr>
      <td>{item.type}</td>
      <td>{item.amount}</td>
      <td>{item.currency}</td>
    </tr>
  )
}

export const TransactionHistory = ({ items }) => {
  return (
    <table className="transaction-history">
      <thead>
        <tr>
          <th>Type</th>
          <th>Amount</th>
          <th>Currency</th>
        </tr>
      </thead>
    
      <tbody>
        {items.map(item => (
          <TransactionItem key={item.id} item={item}/>
        ))}
      </tbody>
    </table>
  )
}